import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-xl">VIP</span>
              </div>
              <span className="text-xl font-bold text-white">VIP Medicale Services</span>
            </div>
            <p className="text-sm">{t.aboutUsDesc}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.quickLinks}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-red-400 transition-colors">
                  {t.home}
                </Link>
              </li>
              <li>
                <Link to="/surgeries" className="text-sm hover:text-red-400 transition-colors">
                  {t.surgeries}
                </Link>
              </li>
              <li>
                <Link to="/quote" className="text-sm hover:text-red-400 transition-colors">
                  {t.quote}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-red-400 transition-colors">
                  {t.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.contact}</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-red-400" />
                <span className="text-sm">vip.medicale.services@gmail.com</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-red-400" />
                <div className="flex flex-col">
                  <span className="text-sm">+216 25 018 450</span>
                  <span className="text-sm">+216 20 383 487</span>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <MapPin className="h-4 w-4 text-red-400" />
                <span className="text-sm">Tunis, Tunisia</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="h-4 w-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
                <a 
                  href="https://vipmedicaleservices.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm hover:text-red-400 transition-colors"
                >
                  vipmedicaleservices.com
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="mt-6">
              <h4 className="text-white font-semibold mb-3">{t.followUs}</h4>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/share/19dugw1oq1/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-400 transition-colors"
                  data-testid="facebook-link"
                >
                  <Facebook className="h-5 w-5" />
                </a>
                <a 
                  href="https://www.instagram.com/vipmedicalservice?igsh=OWdyaWpqdXp3cXZh" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-400 transition-colors"
                  data-testid="instagram-link"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-red-400 transition-colors">
                  <Linkedin className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; 2025 VIP Medicale Services Tunisia. {t.allRightsReserved}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;